import   React  from "react";

import   classNames                  from "classnames";

import   styles                      from "./Dashboard.module.scss";

import   LastLogin                   from './frames/LastLogin'
import   PaymentFrame                from './frames/PaymentFrame'
import   DailySummary                from './frames/DailySummary'
import   DailyRevenue                from './frames/DailyRevenue'
import   MonthlySummary              from './frames/MonthlySummary'
import   BroadcastingChannelsList    from './frames/BroadcastingChannelsList'
import   Audience                    from './frames/Audience'
import   Subscription                from './frames/Subscription'

const Dashboard: React.FC = () => {

  return (
  
    <div className={classNames(styles.dashboard)}>

      <div className={classNames(styles.broadcastingChannels)}>
	    <BroadcastingChannelsList/>
      </div>
      
      <div className={classNames(styles.audience)}>
  	    <Audience/>
      </div>

      <div className={classNames(styles.dailySummary)}>
	    <DailySummary/>
      </div>

      <div className={classNames(styles.dailyRevenuePanel)}>
        <DailyRevenue/>
      </div>

      <div className={classNames(styles.monthlySummary)}>
        <MonthlySummary/>
      </div>

      <div className={classNames(styles.subscription)}>
  	    <Subscription/>
      </div>
	  
      <div className={classNames(styles.paymentPart)}>
        <PaymentFrame/>
      </div>

      <div className={classNames(styles.lastlogin)}>
        <LastLogin/>
      </div>
      
    </div>
  );
};

export default Dashboard;
